import { render, staticRenderFns } from "./Takeover.vue?vue&type=template&id=8c7b9524&"
import script from "./Takeover.vue?vue&type=script&lang=js&"
export * from "./Takeover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports